// extracted by mini-css-extract-plugin
export const marquee = "marquee-module--marquee--xidn6";
export const marqueeGroup = "marquee-module--marqueeGroup--R9b_q";
export const scrollX = "marquee-module--scroll-x--JHBDH";
export const marqueeGroupReverse = "marquee-module--marqueeGroupReverse--1NRNU";
export const marqueeGroupReverseSpeed3 = "marquee-module--marqueeGroupReverseSpeed3--1ppz4";
export const marqueeGroupSpeed2 = "marquee-module--marqueeGroupSpeed2--15-dl";
export const marqueeGroupSpeed3 = "marquee-module--marqueeGroupSpeed3--3i4xR";